module.exports = __webpack_public_path__ + "3bb15e60684a2233eb6e5dfe48cd8e3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./design/photos/schalen/Ruoff_091114x0053.jpg
// module id = 376
// module chunks = 0